import api from "@/api";

const defaultState = {
  filters: {
    age: null,
    entry: null
  }
};

const actions = {};

const mutations = {
  SET_AGE(state, payload) {
    state.filters.age = payload;
  },
  SET_ENTRY(state, payload) {
    state.filters.entry = payload;
    if (payload != "evasion") {
      state.filters.age = null;
    }
  }
};

const getters = {
  filters(state) {
    return state.filters;
  }
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
